import React, { Fragment } from 'react';
import Html from 'components/Html';
import { removeTagsInHtml, replaceTagsInHtml } from 'util/html';
import styles from './styles';

const PROHIBITED_TAGS = [
  'base',
  'picture',
  'frame',
  'frameset',
  'object',
  'param',
  'applet',
  'embed',
  'script'
];

const HANDLED_TAGS = ['img', 'video', 'audio', 'iframe', 'form', 'template'];

function AmpHtml(props) {
  // Remove prohibited tags so AMP validation passes. Note, also remove replaced
  // tags, e.g. img replaced with amp-img, since Html will just dangerously
  // set the value - this is a safeguard since these types should have been
  // explicitly parsed and handled higher up (by Oxygen or Flow).
  const withoutTags = removeTagsInHtml(props.html, [
    ...PROHIBITED_TAGS,
    ...HANDLED_TAGS
  ]);
  // Replace disallowed tags with span. We want to preserve the content of these
  // tags, however the tag itself is disallowed, e.g. <font>
  const html = replaceTagsInHtml(withoutTags, ['font'], 'span');
  return (
    <Fragment>
      <style jsx>{styles}</style>
      <Html {...props} html={html} />
    </Fragment>
  );
}

export default AmpHtml;
